<template>
  <node-view-wrapper
    :class="[extension.options.className, { 'ProseMirror-selectednode': selected }, 'my-2']"
    :data-block-id="props?.node?.attrs?.['block-id']"
  >
    <node-view-content :as="extension.options.tagName" />
  </node-view-wrapper>
</template>

<script setup lang="ts">
/*
  This is a custom node view for the block nodes which is used as a wrapper.
*/
import { NodeViewWrapper, NodeViewContent, nodeViewProps } from '@tiptap/vue-3';

const props = defineProps({
  ...nodeViewProps,
  extension: {
    type: Object,
    required: true,
  },
});
</script>
